// JsFromRoutes CacheKey aca8b833365b6ae96efcf1ca5ac3d810
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  public: definePathHelper('post', '/deals/:deal_id/dashboard/public'),
  private: definePathHelper('post', '/deals/:deal_id/dashboard/private'),
}
